import axiosInstance from "utils/axios";
import { toCamelCaseDeep } from "utils/caseConvert";

// Per-Main-Category configuration of Selection category levels 3+ (alias + optional flag).
// Levels 1 (Main Category) and 2 (Category) are permanently fixed and are never configured here --
// see selectionCategoryService.js for the node tree itself.

const unwrap = (response, fallbackMessage) => {
  if (response.data.statusCode === 200 && response.data.status === "Success") {
    let data = response.data.data;
    if (typeof data === "string" && data.trim()) {
      try {
        data = JSON.parse(data);
      } catch (parseError) {
        console.error("Error parsing response data:", parseError);
        throw new Error("Invalid data format received from server");
      }
    }
    return {
      success: true,
      data: toCamelCaseDeep(data),
      totalRecords: response.data.totalRecords,
      message: response.data.message,
    };
  }
  throw new Error(response.data.message || fallbackMessage);
};

// Returns [] for a brand-new or legacy (pre-config) Main Category -- that's a normal, successful
// response, not an error.
export const getCategoryLevelConfig = async (mainCategoryNodeId) => {
  if (!mainCategoryNodeId) return { success: true, data: [] };
  try {
    const response = await axiosInstance.get(`api/SelectionCategoryLevelConfig/${mainCategoryNodeId}`, {
      showLoader: false,
    });
    const result = unwrap(response, "Failed to fetch category level configuration");
    return { success: true, data: Array.isArray(result.data) ? result.data : [] };
  } catch (error) {
    console.error("Error in getCategoryLevelConfig:", error);
    return {
      success: false,
      data: [],
      error: error.response?.data?.message || error.message || "Failed to fetch category level configuration",
    };
  }
};

export const upsertCategoryLevelConfig = async ({ id, mainCategoryNodeId, levelNumber, alias, isOptional = false }) => {
  try {
    const response = await axiosInstance.post("api/SelectionCategoryLevelConfig/Upsert", {
      id: id || null,
      mainCategoryNodeId,
      levelNumber,
      alias: (alias || "").trim(),
      isOptional: !!isOptional,
    });
    const result = unwrap(response, "Failed to save level configuration");
    return { success: true, data: result.data, message: result.message };
  } catch (error) {
    console.error("Error in upsertCategoryLevelConfig:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to save level configuration",
    };
  }
};

export const deleteCategoryLevelConfig = async (id) => {
  try {
    const response = await axiosInstance.post(`api/SelectionCategoryLevelConfig/Delete/${id}`);
    const result = unwrap(response, "Failed to remove level configuration");
    return { success: true, message: result.message };
  } catch (error) {
    console.error("Error in deleteCategoryLevelConfig:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to remove level configuration",
    };
  }
};
